import auth from "@/plugins/auth";
import router, { constantRoutes, dynamicRoutes } from "@/router";
import { getRouters } from "@/api/menu";
import Layout from "@/layout/index";
import ParentView from "@/components/ParentView";
import InnerLink from "@/layout/components/InnerLink";
import useUserStore from "@/store/modules/user";
import { isJyj } from "@/utils/isState.js";
import { findResourceById } from "@/api/system/menu.js";
// const userStore = useUserStore();
// console.log("11111", userStore.userInfo)

// 匹配views里面所有的.vue文件
const modules = require.context("@/views", true, /\.vue$/);
const usePermissionStore = defineStore("permission", {
  state: () => ({
    routes: [],
    addRoutes: [],
    defaultRoutes: [],
    topbarRouters: [],
    sidebarRouters: [],
    fixedRouters: [
      // {
      //   name: "evaluationRule ",
      //   path: "/evaluationRule",
      //   hidden: false,
      //   redirect: "/evaluationRule/evaluationCategorySettings",
      //   component: "Layout", // alwaysShow: true,
      //   meta: {
      //     title: "素养管理", // icon: "eRIndex.svg",
      //     noCache: false,
      //     icon: "",
      //     link: null,
      //   },
      //   children: [
      //     {
      //       name: "evaluationCategorySettings",
      //       path: "evaluationCategorySettings",
      //       hidden: false,
      //       component: "evaluationRule/evaluationCategorySettings",
      //       meta: {
      //         title: "评价类别设置", // icon: "eRIndex.svg",
      //         noCache: false,
      //         icon: "",
      //         link: null,
      //       },
      //     },
      //     {
      //       name: "evaluationProjectSettings",
      //       path: "evaluationProjectSettings",
      //       hidden: false,
      //       component: "evaluationRule/evaluationProjectSettings",
      //       meta: {
      //         title: "评价项目设置", // icon: "eRIndex.svg",
      //         noCache: false,
      //         icon: "",
      //         link: null,
      //       },
      //     },
      //     {
      //       name: "evaluationGradeSettings",
      //       path: "evaluationGradeSettings",
      //       hidden: false,
      //       component: "evaluationRule/evaluationGradeSettings",
      //       meta: {
      //         title: "评价等次设置", // icon: "eRIndex.svg",
      //         noCache: false,
      //         icon: "",
      //         link: null,
      //       },
      //     },
      //     {
      //       name: "EvaluationAnalysis",
      //       path: "EvaluationAnalysis",
      //       hidden: false,
      //       component: "evaluationRule/EvaluationAnalysis",
      //       meta: {
      //         title: "综合素养评价分析", // icon: "eRIndex.svg",
      //         noCache: false,
      //         icon: "",
      //         link: null,
      //       },
      //     },
      //     {
      //       name: "userDetailsRepeat",
      //       path: "userDetailsRepeat",
      //       hidden: true,
      //       component: "home/userDetails",
      //       meta: {
      //         title: "评价详情", // icon: "sy.png",
      //         icon: "",
      //         noCache: false,
      //         link: null,
      //         activeMenu: "/evaluationRule/EvaluationAnalysis",
      //       },
      //     },
      //   ],
      // },
      // {
      //   name: "userDetailsRepeat",
      //   path: "userDetailsRepeat",
      //   hidden: true,
      //   component: "home/userDetails",
      //   meta: {
      //     title: "评价详情", // icon: "sy.png",
      //     icon: "",
      //     noCache: false,
      //     link: null,
      //     activeMenu: "/indexSys",
      //   },
      // },
      //本地静态路由
      // {
      //   name: "homeSys",
      //   path: "/",
      //   hidden: false,
      //   redirect: "/indexSys",
      //   component: "Layout", // alwaysShow: true,
      //   children: [
      //     {
      //       name: "indexSys",
      //       path: "indexSys",
      //       hidden: false,
      //       component: "home/index",
      //       meta: {
      //         title: "首页", // icon: "sy.png",
      //         icon: "",
      //         noCache: false,
      //         link: null,
      //       },
      //     },
      //     {
      //       name: "userDetails",
      //       path: "userDetails",
      //       hidden: true,
      //       component: "home/userDetails",
      //       meta: {
      //         title: "评价详情", // icon: "sy.png",
      //         icon: "",
      //         noCache: false,
      //         link: null,
      //         activeMenu: "/indexSys",
      //       },
      //     },
      //   ],
      // },
    ]
  }),
  actions: {
    setRoutes(routes) {
      this.addRoutes = routes;
      this.routes = constantRoutes.concat(routes);
    },
    setDefaultRoutes(routes) {
      this.defaultRoutes = constantRoutes.concat(routes);
    },
    // 顶部路由信息
    setTopbarRoutes(routes) {
      this.topbarRouters = routes;
    },
    // 侧边栏路由信息
    setSidebarRouters(routes) {
      this.sidebarRouters = routes;
    },
    generateRoutes(roles) {
      return new Promise(async (resolve, reject) => {
        // 向后端请求路由数据
        const users = useUserStore();
        //处理后台返回路由
        const {
          code,
          data
        } = await findResourceById({
          userType: users.userInfo.userType
        }).catch(error => {
          reject(error);
        });
        console.log(code, data, "路由");
        const map = {
          homeSys: {
            path: "/",
            component: "Layout"
          },
          evaluationRule: {
            path: "/evaluationRule",
            component: "Layout"
          },
          regionalAnalysis: {
            path: "/regionalAnalysis",
            component: "Layout"
          },
          evaluationCategorySettings: {
            path: "/evaluationCategorySettings",
            component: "evaluationRule/evaluationCategorySettings"
          },
          evaluationProjectSettings: {
            path: "/evaluationProjectSettings",
            component: "evaluationRule/evaluationProjectSettings"
          },
          evaluationGradeSettings: {
            path: "/evaluationGradeSettings",
            component: "evaluationRule/evaluationGradeSettings"
          },
          EvaluationAnalysis: {
            path: "/EvaluationAnalysis",
            component: "evaluationRule/EvaluationAnalysis"
          },
          rAIndex: {
            path: "/rAIndex",
            component: "regionalAnalysis/rAIndex"
          },
          rAIndexItem: {
            path: "/rAIndexItem",
            component: "regionalAnalysis/rAIndexItem"
          },
          indexSys: {
            path: "/indexSys",
            component: "textbookResource/approve"
          },
          userDetails: {
            path: "/indexSys",
            component: "home/userDetails"
          },
          userDetailsRepeat: {
            path: "/userDetailsRepeat",
            component: "home/userDetails"
          }
        };
        const diGui = (routers, children = [], index = 0) => {
          routers.map(i => {
            let {
              url: name,
              icon = "",
              name: title,
              resourceInfoVoList = [],
              component,
              hidden = false
            } = i;
            component = map[name].component;
            let obj = {};
            if (index != 0) {
              let activeMenu = null;
              if (name == "userDetails") {
                hidden = true;
                activeMenu = "/indexSys";
              }
              if (name == "userDetailsRepeat") {
                hidden = true;
                activeMenu = "/evaluationRule/EvaluationAnalysis";
              }
              obj = {
                meta: {
                  icon,
                  title,
                  noCache: false,
                  link: null,
                  activeMenu
                },
                name,
                component,
                path: map[name].path.replace("/", ""),
                hidden
              };
            } else {
              obj = {
                name,
                component,
                path: map[name].path,
                meta: {
                  icon,
                  title,
                  noCache: false,
                  link: null
                },
                hidden
              };
            }
            obj.children = diGui(resourceInfoVoList, [], index + 1);
            if (obj.children.length) {
              obj.redirect = (obj.path + obj.children[0].path).replace("//", "/");
            }
            children.push(obj);
          });
          return children;
        };
        let routerList = [];
        if (code == "success") {
          let {
            resourceInfoVoList = [],
            ...value
          } = data;

          // console.log(home, resourceInfoVoList);
          routerList = [...diGui(resourceInfoVoList), ...this.fixedRouters];
        }
        const sdata = JSON.parse(JSON.stringify(routerList));
        const rdata = JSON.parse(JSON.stringify(routerList));
        const defaultData = JSON.parse(JSON.stringify(routerList)); // 过滤出侧边栏路由信息
        const sidebarRoutes = filterAsyncRouter(sdata);
        const rewriteRoutes = filterAsyncRouter(rdata, false, true);
        const defaultRoutes = filterAsyncRouter(defaultData);
        const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
        asyncRoutes.forEach(route => {
          router.addRoute(route);
        });
        this.setRoutes(rewriteRoutes); // 设置侧边栏路由
        this.setSidebarRouters(constantRoutes.concat(sidebarRoutes));
        this.setDefaultRoutes(sidebarRoutes);
        this.setTopbarRoutes(defaultRoutes);
        resolve(rewriteRoutes); // getRouters().then(res => { //   const sdata = JSON.parse(JSON.stringify(res.data)); //   const rdata = JSON.parse(JSON.stringify(res.data)); //   const defaultData = JSON.parse(JSON.stringify(res.data)); //   // 过滤出侧边栏路由信息 //   const sidebarRoutes = filterAsyncRouter(sdata); //   const rewriteRoutes = filterAsyncRouter(rdata, false, true); //   const defaultRoutes = filterAsyncRouter(defaultData); //   const asyncRoutes = filterDynamicRoutes(dynamicRoutes); //   asyncRoutes.forEach(route => { //     router.addRoute(route); //   }); //   this.setRoutes(rewriteRoutes); //   // 设置侧边栏路由 //   this.setSidebarRouters(constantRoutes.concat(sidebarRoutes)); //   this.setDefaultRoutes(sidebarRoutes); //   this.setTopbarRoutes(defaultRoutes); //   resolve(rewriteRoutes); // });
      });
    },
    getUserType() {
      const userStore = useUserStore();
      return userStore.userInfo.userType;
    }
  }
});

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = filterChildren(route.children);
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === "Layout") {
        route.component = Layout;
      } else if (route.component === "ParentView") {
        route.component = ParentView;
      } else if (route.component === "InnerLink") {
        route.component = InnerLink;
      } else {
        route.component = loadView(route.component);
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type);
    } else {
      delete route["children"];
      delete route["redirect"];
    }
    return true;
  });
}
function filterChildren(childrenMap, lastRouter = false) {
  var children = [];
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === "ParentView" && !lastRouter) {
        el.children.forEach(c => {
          c.path = el.path + "/" + c.path;
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c));
            return;
          }
          children.push(c);
        });
        return;
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + "/" + el.path;
    }
    children = children.concat(el);
  });
  return children;
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = [];
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route);
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route);
      }
    }
  });
  return res;
}
export const loadView = view => {
  let res;
  modules.keys().filter(path => path.split("./")[1].split(".vue")[0] === view).forEach(path => {
    if (process.env.NODE_ENV === "development") {
      // res = (resolve) => require([`@/views/${view}`], resolve);
      // res = () => require('@/views' + path).default;
      res = () => import(`@/views/${view}`);
    } else {
      // 使用 import 实现生产环境的路由懒加载
      res = () => import(`@/views/${view}`);
    }
  });
  return res;
};
export default usePermissionStore;